import React from 'react';
import { MapPin, Phone, Info, Calendar, Clock } from 'lucide-react';
import { formatDate } from '@/lib/dateUtils';

/** The workplace logistics for a visit — the same fields parents, mentors and coordinators see. */
export const VisitDetailsCard = ({ venue, mentorName, date, timeSlot, endTime, showWhen = false }) => {
  if (!venue || (!venue.workplace_name && !venue.address)) return null;
  return (
    <div className="ce-card p-5" data-testid="visit-details">
      <h2 className="text-sm font-bold text-[#1F2937] font-['Outfit'] mb-3">Workplace Visit Details</h2>
      <div className="space-y-2.5 text-xs">
        <div className="flex items-start gap-2.5">
          <MapPin className="h-4 w-4 text-[#B0B5C0] mt-0.5 shrink-0" />
          <div>
            <p className="font-semibold text-[#1F2937]" data-testid="visit-workplace">{venue.workplace_name}</p>
            <p className="text-[#6B7280]" data-testid="visit-address">{[venue.address, venue.city].filter(Boolean).join(', ')}</p>
          </div>
        </div>
        {showWhen && (
          <div className="flex items-start gap-2.5" data-testid="visit-when">
            <Calendar className="h-4 w-4 text-[#B0B5C0] mt-0.5 shrink-0" />
            <p className="text-[#4B5563]">{formatDate(date)}</p>
            <Clock className="h-4 w-4 text-[#B0B5C0] mt-0.5 shrink-0" />
            <p className="text-[#4B5563]">{timeSlot}{endTime ? `–${endTime}` : ''}</p>
          </div>
        )}
        {(venue.contact_name || venue.contact_phone) && (
          <div className="flex items-start gap-2.5">
            <Phone className="h-4 w-4 text-[#B0B5C0] mt-0.5 shrink-0" />
            <p className="text-[#4B5563]" data-testid="visit-contact">
              {venue.contact_name}{venue.contact_name && venue.contact_phone ? ' · ' : ''}{venue.contact_phone}
            </p>
          </div>
        )}
        {venue.visit_instructions && (
          <div className="flex items-start gap-2.5">
            <Info className="h-4 w-4 text-[#B0B5C0] mt-0.5 shrink-0" />
            <p className="text-[#4B5563] whitespace-pre-wrap" data-testid="visit-instructions">{venue.visit_instructions}</p>
          </div>
        )}
        <div className="bg-[#F7F8FA] rounded-xl p-3 text-[11px] text-[#6B7280] leading-relaxed" data-testid="visit-supervision">
          {venue.supervised_by === 'workplace_host'
            ? `${venue.host_name || 'An approved workplace host'} supervises the students for the whole visit.`
            : `${mentorName || 'The approved mentor'} supervises the students for the whole visit.`}
          {' '}Parents handle drop-off and pick-up unless the school has arranged transport.
        </div>
      </div>
    </div>
  );
};

export default VisitDetailsCard;
